import React, { FunctionComponent } from "react";
import { useNavigate } from "react-router";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ListItemButton from "@mui/material/ListItemButton";
import CircularProgress from "@mui/material/CircularProgress";

import { ReactComponent as ArrowIcon } from "assets/images/sideMenu/arrow-icon.svg";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

export interface MenuItemI {
  route: string;
  icon: FunctionComponent;
  name: string;
}

interface MenuItemProps {
  item: MenuItemI;
  loading?: boolean;
  onClose: () => void;
  onClick?: () => Promise<void>;
}

const MenuItem: React.FC<MenuItemProps> = React.memo(function MenuItem({
  item,
  loading,
  onClose,
  onClick,
}) {
  const { route, icon: Icon, name } = item;
  const navigate = useNavigate();

  const handleClick = () => {
    onClose();

    if (onClick) {
      onClick();
    } else {
      analytics().sendEvent(`${AnalyticsEvents.mobile_menu_}${route}`);
      navigate(route);
    }
  };

  return (
    <ListItemButton
      sx={{ px: 0, py: 1, mb: 1, color: "grey700" }}
      onClick={handleClick}
      disabled={loading}
    >
      {loading ? <CircularProgress size={24} /> : <Icon />}
      <Typography
        variant="body2"
        sx={{ ml: 1.5, mr: 5 }}
        color={"text.primary"}
      >
        {name}
      </Typography>
      <Box sx={{ ml: "auto" }}>
        <ArrowIcon />
      </Box>
    </ListItemButton>
  );
});

export default MenuItem;
